import React, { Component } from 'react'
import { observer } from 'mobx-react'
import mainStore from '@components/Main/store'
import { Action } from 'hljd'
import style from './style.module.less'
import { hashHistory } from 'react-router'
import { PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID } from '@constant'
import { Auth } from '@common/Auth'

@Auth({ role: [PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID] })
@observer
class Header extends Component {
  render() {
    const { innerComp: Comp } = this.props

    return (
      <div
        className={style.header}
        style={{ top: mainStore.posterStore.hasBannerPoster ? 60 : 0 }}
      >
        <Comp {...this.props} />
      </div>
    )
  }
}

export const WithCommon = WrappedComponent => {
  return class extends Component {
    render() {
      return (
        <>
          <Header {...this.props} innerComp={WrappedComponent} />

          {this.props.children}
        </>
      )
    }
  }
}

export class ActionHeader extends Component {
  constructor(props) {
    super(props)

    const { pathname } = props.location
    const item = props.config.find(item => pathname.includes(item.route))
    this.state = {
      active: item ? item.value : '1'
    }
  }

  getActiveItem = (config, active) => {
    return config.find(item => item.value == active)
  }

  onClick = item => {
    const { link } = this.getActiveItem(this.props.config, item.value)
    hashHistory.push(link)
  }

  render() {
    const { config } = this.props
    const { active } = this.state
    // const parts = this.props.location.pathname.split('/')
    // const lastPart = parts[parts.length - 1]

    // const { back, link } = this.getActiveItem(config, active)

    // if (lastPart && !config.some(item => item.route == lastPart)) {
    //   return (
    //     <Link to={link}>
    //       <Icon type="left" style={{ marginRight: 5 }} />
    //       <span>{back}</span>
    //     </Link>
    //   )
    // }

    return <Action active={active} options={config} onClick={this.onClick} />
  }
}
